import React from 'react'
import { Media } from 'react-breakpoints'
import ContentLoader from 'react-content-loader'

import { useStyles } from './PlaceholderLoader.style'

const PlaceholderLoader = () => {
  const classes = useStyles()

  const bgColor = '#ffffff'
  const fgColor = '#eeeeee'

  return (
    <Media>
      {({ breakpoints, currentBreakpoint }) =>
        breakpoints[currentBreakpoint] < breakpoints.md ? (
          <ContentLoader
            title='Cargando...'
            className={classes.containerHorizontal}
            backgroundColor={bgColor}
            foregroundColor={fgColor}>
            <rect x='15vw' y='30' rx='10' ry='10' width='70vw' height={18} />

            <rect x='6vw' y='100' rx='10' ry='10' width='85vw' height={117} />
            <rect x='6vw' y='250' rx='10' ry='10' width='85vw' height={1023} />
            <rect x='6vw' y='1305' rx='10' ry='10' width='85vw' height={368} />
            <rect x='6vw' y='1700' rx='10' ry='10' width='85vw' height={332} />

            <rect x='22vw' y='2070' rx='10' ry='10' width='55vw' height={48} />
          </ContentLoader>
        ) : (
          <ContentLoader
            title='Cargando...'
            className={classes.containerHorizontal}
            backgroundColor={bgColor}
            foregroundColor={fgColor}>
            <rect x='35vw' y='35' rx='10' ry='10' width='30vw' height={18} />

            <rect x='13vw' y='100' rx='10' ry='10' width='70vw' height={120} />
            <rect x='13vw' y='255' rx='10' ry='10' width='70vw' height={487} />
            <rect x='13vw' y='770' rx='10' ry='10' width='70vw' height={320} />
            <rect x='13vw' y='1120' rx='10' ry='10' width='70vw' height={332} />

            <rect x='42vw' y='1490' rx='10' ry='10' width='15vw' height={48} />
          </ContentLoader>
        )
      }
    </Media>
  )
}

export default PlaceholderLoader
